import { FunctionComponent } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import GuestCheckoutFooter from '@/components/GuestCheckout/GuestCheckoutFooter'
import { trackEvent } from '@/libs/helpers/analytics'
import { GuestInformation } from '@/libs/helpers/apiClient'
import useCookies from '@/libs/helpers/hooks/useCookies'
import { OrderMethod } from '@/libs/helpers/utils'
import { Button, Grid, Text } from '@/tbui'

interface IExistingAccountModalProps {
  continueAsGuest: () => void
  guest: GuestInformation
  venueXRefID: string
  orderMethod: OrderMethod
}

const ExistingAccountModal: FunctionComponent<IExistingAccountModalProps> = ({
  continueAsGuest,
  guest,
  orderMethod,
  venueXRefID,
}) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { setRedirectURLCookie } = useCookies()
  const checkoutPath = `/${orderMethod.toLowerCase()}/${venueXRefID}/checkout`

  const signIn = async (): Promise<void> => {
    // Same data-test as the options modal's sign-in, so the GTM click-scrape
    // counted both as checkout_sign_in.
    trackEvent('checkout_sign_in')
    setRedirectURLCookie({
      url: '/[orderMethod]/[venueXRefID]/checkout',
      as: checkoutPath,
    })
    const queryParams = {
      p: 'B2C_1A_signup_signin',
      login_hint: guest.email,
    }
    router.push(
      `/api/consumer-frontend/auth/azure-b2c/login?${new URLSearchParams(queryParams).toString()}`
    )
  }

  return (
    <Grid gap="1rem" data-test="existing-account-container">
      <Text type="H4" align="center" bold>
        {t('guest_checkout.email_exists_1')}
      </Text>
      <Text type="H4" align="center" bold m="0 0 0.75rem 0">
        {t('guest_checkout.email_exists_2')}
      </Text>
      <Button
        variant="PRIMARY"
        onClick={() => signIn()}
        type="button"
        data-test="guest-checkout-sign-in-btn"
      >
        {t('tbdine.sign_in')}
      </Button>
      <Button
        variant="OUTLINE"
        onClick={() => continueAsGuest()}
        type="button"
        data-test="continue-as-guest-btn"
      >
        {t('guest_checkout.continue_as_guest')}
      </Button>
      <GuestCheckoutFooter />
    </Grid>
  )
}

export default ExistingAccountModal
